export default __webpack_public_path__ + "static/media/my_plan.2c8a0714.svg";